(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  if (isDesignMode) {
    document.documentElement.classList.add('emega-theme-editor');
  }

  const onScroll = () => document.body.classList.toggle('emega-scrolled', window.scrollY > 18);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const initReveal = (root = document) => {
    const revealItems = [...root.querySelectorAll('.emega-reveal')];
    if (!revealItems.length) return;

    // In Shopify's Theme Editor sections are re-rendered whenever an image,
    // text or link setting changes. Keep edited sections visible immediately.
    if (isDesignMode || reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach((el) => revealObserver.observe(el));
  };

  const initHero = (root = document) => {
    root.querySelectorAll('[data-emega-hero]').forEach((hero) => {
      if (hero.dataset.emegaHeroReady === 'true') return;
      hero.dataset.emegaHeroReady = 'true';
      if (reduceMotion || coarsePointer || isDesignMode) return;
      const media = hero.querySelector('[data-emega-hero-media]');
      if (!media) return;
      hero.addEventListener('pointermove', (event) => {
        const r = hero.getBoundingClientRect();
        const nx = (event.clientX - r.left) / r.width - .5;
        const ny = (event.clientY - r.top) / r.height - .5;
        media.style.setProperty('--media-x', `${nx * 10}px`);
        media.style.setProperty('--media-y', `${ny * 8}px`);
        media.style.setProperty('--media-ry', `${nx * 2.8}deg`);
        media.style.setProperty('--media-rx', `${ny * -2.2}deg`);
      });
      hero.addEventListener('pointerleave', () => {
        ['--media-x','--media-y','--media-ry','--media-rx'].forEach((prop) => media.style.removeProperty(prop));
      });
    });
  };

  const initTilt = (root = document) => {
    root.querySelectorAll('[data-emega-tilt]').forEach((card) => {
      if (card.dataset.emegaTiltReady === 'true') return;
      card.dataset.emegaTiltReady = 'true';
      if (reduceMotion || coarsePointer || isDesignMode) return;
      card.addEventListener('pointermove', (event) => {
        const r = card.getBoundingClientRect();
        const x = (event.clientX - r.left) / r.width - .5;
        const y = (event.clientY - r.top) / r.height - .5;
        card.style.setProperty('--tilt-y', `${x * 3.6}deg`);
        card.style.setProperty('--tilt-x', `${y * -3.6}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tilt-y', '0deg');
        card.style.setProperty('--tilt-x', '0deg');
      });
    });
  };

  const initEmega = (root = document) => {
    initReveal(root);
    initHero(root);
    initTilt(root);
  };

  initEmega(document);

  // Shopify Theme Editor events. This prevents an edited image/card from
  // disappearing after Shopify dynamically reloads the section.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target || document;
    root.querySelectorAll?.('.emega-reveal').forEach((el) => el.classList.add('is-revealed'));
    initEmega(root);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target?.closest?.('.shopify-section') || event.target;
    section?.querySelectorAll?.('.emega-reveal').forEach((el) => el.classList.add('is-revealed'));
  });
})();
